import { lazy, useEffect, useRef } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useAuthentication } from 'hooks/useAuthentication'
import { showToast, TOAST_TYPES } from 'ToastUtils'
import Loadable from '../layouts/loader/Loadable'

/****Layouts*****/
const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')))
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')))
/***** Pages ****/

const Starter = Loadable(lazy(() => import('../views/Starter')))

/***** Auth Pages ****/
const LoginPage = Loadable(lazy(() => import('../views/auth/ViewLogin')))
const Error = Loadable(lazy(() => import('../views/auth/Error')))
/*****Routes******/

const AuthRoute = ({ children }) => {
  const { isAuthenticated, logout } = useAuthentication()
  const navigate = useNavigate()

  function getEpochSeconds() {
    const date = new Date()
    const epochSeconds = Math.floor(date.getTime() / 1000)
    return epochSeconds
  }

  function logoutRedirect() {
    showToast(TOAST_TYPES.WARN, 'Session expired', { position: 'top-right', toastId: 132 })
    logout()
    navigate('/login')
  }

  useEffect(() => {
    if (!isAuthenticated) logoutRedirect()
  }, [isAuthenticated])

  useEffect(() => {
    const handleVisibility = (e) => {
      if (document.visibilityState === 'visible') {
        const creds = localStorage.getItem('persist:credentials')
        const expiration = Number(JSON.parse(creds).expiration ?? 0)
        const now = getEpochSeconds()
        const expired = now >= Number(expiration)

        if (expired) {
          logoutRedirect()
        }
      }
    }

    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [])

  // const isAuthenticated =
  //   useSelector((state) => state.auth.isAuthenticated) && localStorage.getItem('token') != null

  return isAuthenticated ? { ...children } : <Navigate to="/login" />
}

AuthRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

const ThemeRoutes = [
  {
    path: '/',
    element: (
      <AuthRoute>
        <FullLayout />
      </AuthRoute>
    ),
    children: [
      { path: '/', element: <Navigate to="/starter" /> },
      { path: '/starter', exact: true, element: <Starter /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  { path: '/login', element: <LoginPage /> },
  // {
  //   path: '/auth',
  //   element: <BlankLayout />,
  //   children: [
  //     { path: '404', element: <Error /> },
  //     { path: '*', element: <Navigate to="/auth/404" /> },
  //   ],
  // },
]

export default ThemeRoutes
